module.exports = __webpack_public_path__ + "img/ai1.aeb767f5.jpg";